import Vue from 'vue/dist/vue.js';
import * as VeeValidate from 'vee-validate';
import axios from 'axios';


window.Vue = Vue;
Vue.use(VeeValidate);
window.axios = require('axios');